import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss']
})
export class ForbiddenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
   
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/forbidden/forbidden.component.ts